export const styles = {
    app:{
      backgroundColor:'rgba(0,0,0,0.1)',
      justifyItems:'center',
      alignItems:'center',
      display:'grid',
      height:'100vh',
      fontFamily:'Arial',
      color:'rgba(0,0,100,1)',
      gridTemplateColumns:'1fr',
      fontSize:25
    },
    select:{
      width:'100%',
      padding:"10px 10px",
      // maxWidth:600
    },
    option: {
        backgroundColor:"red",
        padding:"10px 10px",

    }
  }